import React, { useEffect, useState } from "react";

// Models
import SponsorAdmin from "models/SponsorAdmin/SponsorAdmin";

// Contexts
import SponsorAdminContext from "contexts/SponsorAdmin";

// Hooks
import useSponsorAdmin from "hooks/useSponsorAdmin";

// Utils
import { isPosing } from "utils/posing/posing";

function SponsorAdminProvider({ children }) {
  const [sponsorAdminResource] = useSponsorAdmin();
  const [sponsorAdmin, setSponsorAdmin] = useState(new SponsorAdmin());

  useEffect(() => {
    if (!sponsorAdminResource.isLoading) {
      if (sponsorAdminResource.error && isPosing()) {
        setSponsorAdmin(SponsorAdmin.posingAdmin);
      } else {
        setSponsorAdmin(sponsorAdminResource.model);
      }
    }
  }, [sponsorAdminResource.isLoading, sponsorAdminResource.error, sponsorAdminResource.model]);

  return (
    <SponsorAdminContext.Provider value={sponsorAdmin}>{children}</SponsorAdminContext.Provider>
  );
}

export default SponsorAdminProvider;
